export const startingWiewButton = {
  marginTop: "1rem",
  width: "100%"
}